module.exports = __webpack_public_path__ + "img/round1.3b18bc56.svg";